import { render, staticRenderFns } from "./ButtonGroup.vue?vue&type=template&id=b2034f8c&scoped=true"
import script from "./ButtonGroup.vue?vue&type=script&lang=ts"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts"
import style0 from "./ButtonGroup.vue?vue&type=style&index=0&id=b2034f8c&prod&lang=scss&scoped=true"
import style1 from "./ButtonGroup.vue?vue&type=style&index=1&id=b2034f8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2034f8c",
  null
  
)

export default component.exports